<script setup lang="ts">

import { GetTheAppButton } from "@components/GetTheAppButton"
import { NavigationItems } from "@components/NavigationItems"; 


</script>

<template>

    <div class="header-shadow sticky top-0 bg-white dark:bg-gray-900"> 
        <div class="max-w-5xl mx-auto p-2 md:p-5 flex items-center justify-center md:justify-start">
            <RouterLink to="/"
                        class="text-center">
                <img src="@/assets/images/carbucks.png" class="h-16"/>
                <div class="uppercase text-[0.66rem] -mt-3">Healthy Car &middot; Happy Wallet</div>
            </RouterLink>
            <div class="hidden md:flex flex-1 items-center">
                <div class="flex-1 flex justify-end items-center pr-12 gap-x-12
                            font-semibold text-black">
                    <NavigationItems />
                </div>
                <GetTheAppButton :show-get-in-touch="false" />
            </div>
        </div>

    </div>

</template>

<style lang="scss">

    .header-shadow
    {
        box-shadow: 0 1px 1px rgba(0,0,0,0.01), 
              0 2px 2px rgba(0,0,0,0.01), 
              0 4px 4px rgba(0,0,0,0.01), 
              0 8px 8px rgba(0,0,0,0.01),
              0 16px 16px rgba(0,0,0,0.01);
    }

</style>